<kodit-loader [content]="content" [showLoader]="showLoadingPage"></kodit-loader>
<kodit-blockable-div #content>
  <kodit-sub-expired-topbar></kodit-sub-expired-topbar>
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
</kodit-blockable-div>
<kodit-profil-sidebar [isExpiredLayout]="true"></kodit-profil-sidebar>
